import { HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod } from '@api-new/authservice';

export const ENUM_SignUpCreationMethodRecord: Record<HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod, string> = {
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_UNSPECIFIED]: 'Unspecified',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_MORTGAGE_MONITOR]: 'Mortgage Monitor',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_REMORTGAGE_NOW]: 'Remortgage Now',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_FIRST_TIME_BUYER]: 'First Time Buyer',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_MOVING_HOME]: 'Moving Home',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_BUY_TO_LET]: 'Buy To Let',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.SIGN_UP_CREATION_METHOD_LANDLORD]: 'Landlord',
  [HTTP_CP_SignUp_Request_ENUM_SignUpCreationMethod.UNRECOGNIZED]: 'Unrecognized',
};
